/* ================================================================
   Custom Order Module
   ================================================================ */

/* ──────────────────────────────────────────────────────────────────
   PRICING CONFIG — update these values to adjust pricing
   All prices are $ per increment of 50 units
   ────────────────────────────────────────────────────────────────── */
/*
const PRICING = {
  standard: {
    'Custom Logo':        '',
    'Text Only':          '',
    'Custom Logo + Text': ''
  },
  custom: {
    'Custom Logo':        '',
    'Text Only':          '',
    'Custom Logo + Text': ''
  }
};
*/

const QTY_MIN_STANDARD   = 72;
const QTY_MIN_CUSTOM     = 300;
const QTY_STANDARD_OPTIONS = [QTY_MIN_STANDARD, 120, QTY_MIN_CUSTOM, '300+'];
const QTY_CUSTOM_OPTIONS   = [QTY_MIN_CUSTOM, '300+'];
const CUSTOM_PATTERN_VAL = 'Custom Artwork';
const CONTACT_EMAIL      = 'hello@shoptuckshop.com';

/* ── Preview images — keyed by [pattern][flavor] ─────────────── */
const CDN = 'https://cdn.shopify.com/s/files/1/0749/0099/6404/files/';
const CUSTOM_ARTWORK_BASE = CDN + 'custom-artwork-custom-chocolate-bar-linen.jpg?v=1786079149';

const PREVIEW_IMAGES = {
  'Charleston': {
    '':                              CDN + 'charleston-custom-chocolate-bar.jpg?v=1790885239',
    'Dark Chocolate with Sea Salt':  CDN + 'charleston-custom-sea-salt.jpg?v=1790885239',
    'Milk Chocolate':                CDN + 'charleston-custom-milk-chocolate.jpg?v=1790885240',
    'Dark Chocolate with Cranberry': CDN + 'charleston-custom-cranberry.jpg?v=1790885240',
    'Dark Chocolate with Pretzel':   CDN + 'charleston-custom-pretzel.jpg?v=1790885240',
    'Dark Chocolate with Almond':    CDN + 'charleston-custom-almond.jpg?v=1790885240',
    'Dark Chocolate with Orange':    CDN + 'charleston-custom-orange.jpg?v=1790885240',
    'Dark Chocolate with Mint':      CDN + 'charleston-custom-mint.jpg?v=1790885240'
  },
  'Chicago': {
    '':                              CDN + 'chicago-custom-chocolate-bar.jpg?v=1790885185',
    'Dark Chocolate with Sea Salt':  CDN + 'chicago-custom-sea-salt.jpg?v=1790885185',
    'Milk Chocolate':                CDN + 'chicago-custom-milk-chocolate.jpg?v=1790885186',
    'Dark Chocolate with Cranberry': CDN + 'chicago-custom-cranberry.jpg?v=1790885186',
    'Dark Chocolate with Pretzel':   CDN + 'chicago-custom-pretzel.jpg?v=1790885185',
    'Dark Chocolate with Almond':    CDN + 'chicago-custom-almond.jpg?v=1790885186',
    'Dark Chocolate with Orange':    CDN + 'chicago-custom-orange.jpg?v=1790885186',
    'Dark Chocolate with Mint':      CDN + 'chicago-custom-mint.jpg?v=1790885185'
  },
  'Hamptons': {
    '':                              CDN + 'hamptons-custom-chocolate-bar.jpg?v=1786074905',
    'Dark Chocolate with Sea Salt':  CDN + 'hamptons-custom-chocolate-bar-sea-salt.jpg?v=1786454917',
    'Milk Chocolate':                CDN + 'hamptons-custom-chocolate-bar-milk-chocolate.jpg?v=1786454916',
    'Dark Chocolate with Cranberry': CDN + 'hamptons-custom-chocolate-bar-cranberry.jpg?v=1786454916',
    'Dark Chocolate with Pretzel':   CDN + 'hamptons-custom-chocolate-bar-pretzel.jpg?v=1786454917',
    'Dark Chocolate with Almond':    CDN + 'hamptons-custom-chocolate-bar-almond.jpg?v=1786454916',
    'Dark Chocolate with Orange':    CDN + 'hamptons-custom-chocolate-bar-orange.jpg?v=1786454917',
    'Dark Chocolate with Mint':      CDN + 'hamptons-custom-chocolate-bar-mint.jpg?v=1786456212'
  },
  'Los Angeles': {
    '':                              CDN + 'los-angeles-custom-chocolate-bar.jpg?v=1786074905',
    'Dark Chocolate with Sea Salt':  CDN + 'los-angeles-custom-chocolate-bar-sea-salt.jpg?v=1786457061',
    'Milk Chocolate':                CDN + 'los-angeles-custom-chocolate-bar-milk-chocolate.jpg?v=1786457060',
    'Dark Chocolate with Cranberry': CDN + 'los-angeles-custom-chocolate-bar-cranberry.jpg?v=1786457060',
    'Dark Chocolate with Pretzel':   CDN + 'los-angeles-custom-chocolate-bar-pretzel.jpg?v=1786457060',
    'Dark Chocolate with Almond':    CDN + 'los-angeles-custom-chocolate-bar-almond.jpg?v=1786457061',
    'Dark Chocolate with Orange':    CDN + 'los-angeles-custom-chocolate-bar-orange.jpg?v=1786457060',
    'Dark Chocolate with Mint':      CDN + 'los-angeles-custom-chocolate-bar-mint.jpg?v=1786457060'
  },
  'Mahjong': {
    '':                              CDN + 'mahjong-custom-chocolate-bar.jpg?v=1790885344',
    'Dark Chocolate with Sea Salt':  CDN + 'mahjong-custom-sea-salt.jpg?v=1790885344',
    'Milk Chocolate':                CDN + 'mahjong-custom-milk-chocolate.jpg?v=1790885345',
    'Dark Chocolate with Cranberry': CDN + 'mahjong-custom-cranberry.jpg?v=1790885345',
    'Dark Chocolate with Pretzel':   CDN + 'mahjong-custom-pretzel.jpg?v=1790885344',
    'Dark Chocolate with Almond':    CDN + 'mahjong-custom-almond.jpg?v=1790885344',
    'Dark Chocolate with Orange':    CDN + 'mahjong-custom-orange.jpg?v=1790885344',
    'Dark Chocolate with Mint':      CDN + 'mahjong-custom-mint.jpg?v=1790885345'
  },
  'Nantucket': {
    '':                              CDN + 'nantucket-custom-chocolate-bar.jpg?v=1786074905',
    'Dark Chocolate with Sea Salt':  CDN + 'nantucket-custom-chocolate-bar-sea-salt.jpg?v=1786456588',
    'Milk Chocolate':                CDN + 'nantucket-custom-chocolate-bar-milk-chocolate.jpg?v=1786456588',
    'Dark Chocolate with Cranberry': CDN + 'nantucket-custom-chocolate-bar-cranberry.jpg?v=1786456588',
    'Dark Chocolate with Pretzel':   CDN + 'nantucket-custom-chocolate-bar-pretzel.jpg?v=1786456588',
    'Dark Chocolate with Almond':    CDN + 'nantucket-custom-chocolate-bar-almond.jpg?v=1786456588',
    'Dark Chocolate with Orange':    CDN + 'nantucket-custom-chocolate-bar-orange.jpg?v=1786456588',
    'Dark Chocolate with Mint':      CDN + 'nantucket-custom-chocolate-bar-mint.jpg?v=1786456588'
  },
  'New York': {
    '':                              CDN + 'new-york-custom-chocolate-bar.jpg?v=1786074905',
    'Dark Chocolate with Sea Salt':  CDN + 'new-york-custom-chocolate-bar-sea-salt.jpg?v=1786457269',
    'Milk Chocolate':                CDN + 'new-york-custom-chocolate-bar-milk-chocolate.jpg?v=1786457269',
    'Dark Chocolate with Cranberry': CDN + 'new-york-custom-chocolate-bar-cranberry.jpg?v=1786457269',
    'Dark Chocolate with Pretzel':   CDN + 'new-york-custom-chocolate-bar-pretzel.jpg?v=1786457269',
    'Dark Chocolate with Almond':    CDN + 'new-york-custom-chocolate-bar-almond.jpg?v=1786457269',
    'Dark Chocolate with Orange':    CDN + 'new-york-custom-chocolate-bar-orange.jpg?v=1786457269',
    'Dark Chocolate with Mint':      CDN + 'new-york-custom-chocolate-bar-mint.jpg?v=1786457269'
  },
  'Palm Beach': {
    '':                              CDN + 'palm-beach-custom-chocolate-bar.jpg?v=1786074905',
    'Dark Chocolate with Sea Salt':  CDN + 'palm-beach-custom-chocolate-bar-sea-salt.jpg?v=1786456810',
    'Milk Chocolate':                CDN + 'palm-beach-custom-chocolate-bar-milk-chocolate.jpg?v=1786456811',
    'Dark Chocolate with Cranberry': CDN + 'palm-beach-custom-chocolate-bar-cranberry.jpg?v=1786456811',
    'Dark Chocolate with Pretzel':   CDN + 'palm-beach-custom-chocolate-bar-pretzel.jpg?v=1786456811',
    'Dark Chocolate with Almond':    CDN + 'palm-beach-custom-chocolate-bar-almond.jpg?v=1786456811',
    'Dark Chocolate with Orange':    CDN + 'palm-beach-custom-chocolate-bar-orange.jpg?v=1786456811',
    'Dark Chocolate with Mint':      CDN + 'palm-beach-custom-chocolate-bar-mint.jpg?v=1786456811'
  },
  'Spring': {
    '':                              CDN + 'spring-custom-chocolate-bar.jpg?v=1788458102',
    'Dark Chocolate with Sea Salt':  CDN + 'spring-custom-chocolate-bars-sea-salt.jpg?v=1788458103',
    'Milk Chocolate':                CDN + 'spring-custom-chocolate-bars-milk-chocolate.jpg?v=1788458102',
    'Dark Chocolate with Cranberry': CDN + 'spring-custom-chocolate-bars-cranberry.jpg?v=1788458103',
    'Dark Chocolate with Pretzel':   CDN + 'spring-custom-chocolate-bars-pretzel.jpg?v=1788458103',
    'Dark Chocolate with Almond':    CDN + 'spring-custom-chocolate-bars-almond.jpg?v=1788458102',
    'Dark Chocolate with Orange':    CDN + 'spring-custom-chocolate-bars-orange.jpg?v=1788458103',
    'Dark Chocolate with Mint':      CDN + 'spring-custom-chocolate-bars-mint.jpg?v=1788458103'
  },
  'Tuck Shop Tan': {
    '':                              CDN + 'ts-toile-tan-custom-chocolate-bar.jpg?v=1791393938',
    'Dark Chocolate with Sea Salt':  CDN + 'ts-toile-tan-custom-sea-salt.jpg?v=1791393938',
    'Milk Chocolate':                CDN + 'ts-toile-tan-custom-milk-chocolate.jpg?v=1791393938',
    'Dark Chocolate with Cranberry': CDN + 'ts-toile-tan-custom-cranberry.jpg?v=1791393938',
    'Dark Chocolate with Pretzel':   CDN + 'ts-toile-tan-custom-pretzel.jpg?v=1791393938',
    'Dark Chocolate with Almond':    CDN + 'ts-toile-tan-custom-almond.jpg?v=1791393938',
    'Dark Chocolate with Orange':    CDN + 'ts-toile-tan-custom-orange.jpg?v=1791393938',
    'Dark Chocolate with Mint':      CDN + 'ts-toile-tan-custom-mint.jpg?v=1791393938'
  },
  'Tuck Shop Blue': {
    '':                              CDN + 'ts-toile-blue-custom-chocolate-bar.jpg?v=1791393959',
    'Dark Chocolate with Sea Salt':  CDN + 'ts-toile-blue-custom-sea-salt.jpg?v=1791393959',
    'Milk Chocolate':                CDN + 'ts-toile-blue-custom-milk-chocolate.jpg?v=1791393959',
    'Dark Chocolate with Cranberry': CDN + 'ts-toile-blue-custom-cranberry.jpg?v=1791393959',
    'Dark Chocolate with Pretzel':   CDN + 'ts-toile-blue-custom-pretzel.jpg?v=1791393959',
    'Dark Chocolate with Almond':    CDN + 'ts-toile-blue-custom-almond.jpg?v=1791393959',
    'Dark Chocolate with Orange':    CDN + 'ts-toile-blue-custom-orange-2.jpg?v=1791394147',
    'Dark Chocolate with Mint':      CDN + 'ts-toile-blue-custom-mint.jpg?v=1791393959'
  },
  'Winter': {
    '':                              CDN + 'winter-custom-chocolate-bar.jpg?v=1788458064',
    'Dark Chocolate with Sea Salt':  CDN + 'winter-custom-chocolate-bars-sea-salt.jpg?v=1788458064',
    'Milk Chocolate':                CDN + 'winter-custom-chocolate-bars-milk-chocolate.jpg?v=1788458064',
    'Dark Chocolate with Cranberry': CDN + 'winter-custom-chocolate-bars-cranberry.jpg?v=1788458064',
    'Dark Chocolate with Pretzel':   CDN + 'winter-custom-chocolate-bars-pretzel.jpg?v=1788458064',
    'Dark Chocolate with Almond':    CDN + 'winter-custom-chocolate-bars-almond.jpg?v=1788458064',
    'Dark Chocolate with Orange':    CDN + 'winter-custom-chocolate-bars-orange.jpg?v=1788458064',
    'Dark Chocolate with Mint':      CDN + 'winter-custom-chocolate-bars-mint.jpg?v=1788458064'
  }
};

const CUSTOM_ARTWORK_LABELS = {
  '':                              CDN + 'custom-artwork-custom-chocolate-bar-label.png?v=1786079149',
  'Dark Chocolate with Sea Salt':  CDN + 'custom-artwork-custom-chocolate-bar-label-sea-salt.png?v=1786457751',
  'Milk Chocolate':                CDN + 'custom-artwork-custom-chocolate-bar-label-milk-chocolate.png?v=1786457751',
  'Dark Chocolate with Cranberry': CDN + 'custom-artwork-custom-chocolate-bar-label-cranberry.png?v=1786457752',
  'Dark Chocolate with Pretzel':   CDN + 'custom-artwork-custom-chocolate-bar-label-pretzel.png?v=1786457751',
  'Dark Chocolate with Almond':    CDN + 'custom-artwork-custom-chocolate-bar-label-almond.png?v=1786457752',
  'Dark Chocolate with Orange':    CDN + 'custom-artwork-custom-chocolate-bar-label-orange.png?v=1786457751',
  'Dark Chocolate with Mint':      CDN + 'custom-artwork-custom-chocolate-bar-label-mint.png?v=1786457751'
};
/* ────────────────────────────────────────────────────────────────── */

const section         = document.getElementById('customOrder');
const flavorSelect    = document.getElementById('flavor');
const patternInputs   = Array.from(document.querySelectorAll('input[name="pattern"]'));
const patternLabel    = document.getElementById('patternLabel');
const artworkField    = document.getElementById('artworkUploadField');
const artworkFile     = document.getElementById('artworkFile');
const artworkFileName = document.getElementById('artworkFileName');
const bandInputs      = Array.from(document.querySelectorAll('input[name="band"]'));
const logoField       = document.getElementById('logoUploadField');
const logoFile        = document.getElementById('logoFile');
const logoFileName    = document.getElementById('logoFileName');
const bandTextFields  = document.getElementById('bandTextFields');
const bandLine1       = document.getElementById('bandLine1');
const bandLine2       = document.getElementById('bandLine2');
const qtySelect       = document.getElementById('quantity');
const qtyMinLabel     = document.getElementById('qtyMinLabel');
// const productPrice    = document.getElementById('productPrice');
const startConvBtn    = document.getElementById('startConversationBtn');
const stepPips        = Array.from(document.querySelectorAll('.step-pip'));
const previewOverlays = Array.from(document.querySelectorAll('.preview-overlay'));
const previewBandLogo = document.getElementById('previewBandLogo');
const previewBandText = document.getElementById('previewBandText');

/* ── Helpers ──────────────────────────────────────────────────── */
const getPattern = () => document.querySelector('input[name="pattern"]:checked')?.value ?? '';
const getBand    = () => document.querySelector('input[name="band"]:checked')?.value ?? '';
const isCustom   = () => getPattern() === CUSTOM_PATTERN_VAL;

/*
function calcPrice() {
  const tier = isCustom() ? 'custom' : 'standard';
  const band = getBand();
  if (!band) return null;
  const rate = PRICING[tier]?.[band];
  if (rate == null) return null;
  const qty = parseInt(qtySelect.value, 10) || QTY_MIN_STANDARD;
  return (qty / QTY_STEP) * rate;
}

function fmtPrice(val) {
  if (val == null) return '';
  return '$' + val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
*/

/* ── Quantity rebuild ─────────────────────────────────────────── */
function rebuildQty() {
  const options = isCustom() ? QTY_CUSTOM_OPTIONS : QTY_STANDARD_OPTIONS;
  const min = options[0];

  qtySelect.innerHTML = '';
  for (const quantity of options) {
    const opt = document.createElement('option');
    opt.value = quantity;
    opt.textContent = quantity;
    qtySelect.appendChild(opt);
  }

  qtySelect.value = min;
  qtyMinLabel.textContent = `${min} bar minimum`;
}

/* ── Price display (disabled) ──────────────────────────────────
function updatePrice() {
  productPrice.textContent = fmtPrice(calcPrice());
}
*/

let patternTouched  = false;
let artworkUploaded = false;

/* ── Step pip indicators ──────────────────────────────────────── */
function updatePips() {
  const bandDone = !!getBand();
  const states = [
    !!flavorSelect.value,
    patternTouched,
    bandDone,
    bandDone
  ];
  stepPips.forEach((pip, i) => pip.classList.toggle('active', states[i]));
}

/* ── Pattern change ───────────────────────────────────────────── */
function onPatternChange(fromInit = false) {
  if (!fromInit) patternTouched = true;
  const val = getPattern();
  if (patternLabel) patternLabel.textContent = val;

  const isCustomArtwork = val === CUSTOM_PATTERN_VAL;
  artworkField.hidden = !isCustomArtwork;

  const disclaimer = document.getElementById('customArtworkDisclaimer');
  if (disclaimer) disclaimer.hidden = !isCustomArtwork;

  updatePreview();

  rebuildQty();
  // updatePrice();
  updatePips();
  refreshMailto();
}

/* ── Band change ──────────────────────────────────────────────── */
function onBandChange() {
  const val       = getBand();
  const needsLogo = val === 'Custom Logo' || val === 'Custom Logo + Text';
  const needsText = val === 'Custom Logo + Text' || val === 'Text Only';

  logoField.hidden      = !needsLogo;
  bandTextFields.hidden = !needsText;

  if (!needsLogo) {
    previewBandLogo.src = '';
    previewBandLogo.classList.remove('is-visible');
  }

  if (!needsText) {
    if (bandLine1) bandLine1.value = '';
    if (bandLine2) bandLine2.value = '';
    if (previewBandText) previewBandText.innerHTML = '';
  }

  // updatePrice();
  updatePips();
  refreshMailto();
  updateBandPreview();
}

/* ── Live band preview ────────────────────────────────────────── */
function updateBandPreview() {
  if (!previewBandText) return;
  const l1 = bandLine1?.value?.trim() || '';
  const l2 = bandLine2?.value?.trim() || '';
  const parts = [];
  if (l1) parts.push(`<div class="band-line-1">${l1}</div>`);
  if (l2) parts.push(`<div class="band-line-2">${l2}</div>`);
  previewBandText.innerHTML = parts.join('');
}

/* ── Logo upload preview ──────────────────────────────────────── */
function onLogoChange() {
  const file = logoFile?.files?.[0];
  if (!file) return;
  if (logoFileName) logoFileName.textContent = file.name;
  document.getElementById('logoClearBtn')?.removeAttribute('hidden');

  const reader = new FileReader();
  reader.onload = (e) => {
    previewBandLogo.src = e.target.result;
    previewBandLogo.classList.add('is-visible');
  };
  reader.readAsDataURL(file);
}

function clearLogo() {
  logoFile.value = '';
  if (logoFileName) logoFileName.textContent = '';
  document.getElementById('logoClearBtn')?.setAttribute('hidden', '');
  previewBandLogo.src = '';
  previewBandLogo.classList.remove('is-visible');
}

function onArtworkChange() {
  const file = artworkFile?.files?.[0];
  if (!file) return;
  if (artworkFileName) artworkFileName.textContent = file.name;
  document.getElementById('artworkClearBtn')?.removeAttribute('hidden');

  const artworkPreviewImg = document.getElementById('artworkPreviewImg');
  if (artworkPreviewImg) {
    const reader = new FileReader();
    reader.onload = (e) => {
      artworkPreviewImg.src = e.target.result;
      artworkPreviewImg.classList.add('is-active');
      artworkUploaded = true;
      const label = document.getElementById('customArtworkLabel');
      if (label) {
        label.src = CUSTOM_ARTWORK_LABELS[flavorSelect.value] || CUSTOM_ARTWORK_LABELS[''];
        label.classList.add('is-active');
      }
    };
    reader.readAsDataURL(file);
  }
}

function clearArtwork() {
  artworkFile.value = '';
  if (artworkFileName) artworkFileName.textContent = '';
  document.getElementById('artworkClearBtn')?.setAttribute('hidden', '');
  artworkUploaded = false;
  const artworkPreviewImg = document.getElementById('artworkPreviewImg');
  if (artworkPreviewImg) {
    artworkPreviewImg.src = '';
    artworkPreviewImg.classList.remove('is-active');
  }
  const label = document.getElementById('customArtworkLabel');
  if (label) label.classList.remove('is-active');
}

/* ── Mailto builder ───────────────────────────────────────────── */
function buildMailto() {
  const flavor  = flavorSelect.value;
  const pattern = getPattern();
  const band    = getBand();
  const qty     = qtySelect.value;
  // const price   = fmtPrice(calcPrice());
  const l1      = bandLine1?.value?.trim() || '—';
  const l2      = bandLine2?.value?.trim() || '—';
  const logo    = logoFile?.files?.length ? 'Yes (will provide separately)' : 'No';
  const artwork = artworkFile?.files?.length ? 'Yes (will provide separately)' : 'N/A';

  const body = [
    'Hello Tuck Shop Team,',
    '',
    'I would like to place a custom chocolate order with the following details:',
    '',
    `Flavor:            ${flavor}`,
    `Pattern:           ${pattern}`,
    `Custom Artwork:    ${artwork}`,
    `Band Option:       ${band}`,
    `Logo Included:     ${logo}`,
    `First Line:        ${l1}`,
    `Second Line:       ${l2}`,
    `Quantity:          ${qty} bars`,
    // `Estimated Total:   ${price || 'TBD'}`,
    '',
    'Please contact me to discuss next steps. Thank you!'
  ].join('\n');

  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('Tuck Shop Custom Order Inquiry')}&body=${encodeURIComponent(body)}`;
}

function refreshMailto() {
  if (startConvBtn) startConvBtn.href = buildMailto();
}

/* ── Preview update (pattern + flavor combined) ──────────────── */
function updatePreview() {
  const pattern = getPattern();
  const flavor  = flavorSelect.value;
  const isCustomArtwork = pattern === CUSTOM_PATTERN_VAL;

  const previewBase       = document.getElementById('previewBase');
  const artworkPreviewImg = document.getElementById('artworkPreviewImg');
  const labelOverlay      = document.getElementById('customArtworkLabel');

  if (isCustomArtwork) {
    if (previewBase) {
      previewBase.src           = CUSTOM_ARTWORK_BASE;
      previewBase.style.opacity = '';
    }
    if (artworkPreviewImg) artworkPreviewImg.classList.toggle('is-active', artworkUploaded);
    if (labelOverlay && artworkUploaded) {
      labelOverlay.src = CUSTOM_ARTWORK_LABELS[flavor] || CUSTOM_ARTWORK_LABELS[''];
      labelOverlay.classList.add('is-active');
    } else if (labelOverlay) {
      labelOverlay.classList.remove('is-active');
    }
  } else if (PREVIEW_IMAGES[pattern]) {
    const imageSrc = PREVIEW_IMAGES[pattern][flavor] || PREVIEW_IMAGES[pattern][''];
    if (previewBase) {
      previewBase.src           = imageSrc;
      previewBase.style.opacity = '';
    }
    if (artworkPreviewImg) artworkPreviewImg.classList.remove('is-active');
    if (labelOverlay) labelOverlay.classList.remove('is-active');
  }

  previewOverlays.forEach(img => {
    if (img.id === 'artworkPreviewImg') return;
    if (img.id === 'customArtworkLabel') return;
    img.classList.toggle('is-active', img.dataset.pattern === pattern);
  });
}

/* ── Event listeners ──────────────────────────────────────────── */
patternInputs.forEach(el => el.addEventListener('change', () => onPatternChange()));
bandInputs.forEach(el => el.addEventListener('change', onBandChange));
flavorSelect.addEventListener('change', () => { updatePips(); refreshMailto(); updatePreview(); });
qtySelect.addEventListener('change', () => { refreshMailto(); });
bandLine1?.addEventListener('input', () => { updateBandPreview(); refreshMailto(); });
bandLine2?.addEventListener('input', () => { updateBandPreview(); refreshMailto(); });
logoFile?.addEventListener('change', onLogoChange);
artworkFile?.addEventListener('change', onArtworkChange);
document.getElementById('logoClearBtn')?.addEventListener('click', clearLogo);
document.getElementById('artworkClearBtn')?.addEventListener('click', clearArtwork);

/* ── Init ─────────────────────────────────────────────────────── */
onPatternChange(true);
// updatePrice();
updatePips();
refreshMailto();
